import { api, apiDev } from "./api";

export interface DropdownClassData {
  DataId: number;
  DataCode: string | null;
  DataCode2: string | null;
  DataCode3: string | null;
  DataLabel: string;
  Description: string | null;
}

export interface DropdownResponse {
  dropdownClassDatas: DropdownClassData[];
  TotalRecord: number;
  Code: number;
  Message: string;
}

export const fetchdropdownMall = async (referenceid: number) => {
  try {
    const url = `/dropdown/v1/getmall?referenceid=${referenceid}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchdropdownTenant = async (referenceid: number) => {
  try {
    const url = `/dropdown/v1/gettenant?referenceid=${referenceid}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchdropdownTenantHO = async (referenceid = 0) => {
  try {
    const url = `/dropdown/v1/gettenantho?referenceid=${referenceid}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchdropdownSafetyStatus = async (referenceid: number) => {
  try {
    const url = `/dropdown/v1/getsafetystatus?referenceid=${referenceid}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const DropdownJobTitle = async (referenceid: number) => {
  try {
    const url = `/dropdown/v1/jobtitle?referenceid=${referenceid}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const GetRequestStatusTenant = async (referenceid: number) => {
  try {
    const url = `/dropdown/v1/getrequeststatustenant?referenceid=${referenceid}`;
    const response = await api.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const DropdownPermitType = async (referenceid: number) => {
  try {
    const url = `/dropdown/v1/getworkpermittype?referenceid=${referenceid}`;
    const response = await apiDev.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const DropdownPermitStatus = async (referenceid: number) => {
  const url = `/dropdown/v1/getpermitrequeststatus?referenceid=${referenceid}`;
  const response = await apiDev.get(url);
  if (response.status === 200) return response.data;
};

export const DropdownPermitRequester = async (referenceid: number) => {
  const url = `/dropdown/v1/getpermitrequester?referenceid=${referenceid}`;
  const response = await api.get(url);
  if (response.status === 200) return response.data;
};

export const DropdownLoadingDoor = async (referenceid: number) => {
  const url = `/dropdown/v1/getloadingdoor?referenceid=${referenceid}`;
  const response = await api.get(url);
  if (response.status === 200) return response.data;
};

export const DropdownAnnouncementType = async (referenceid: number) => {
  try {
    const url = `/dropdown/v1/getannouncementtypeid?referenceid=${referenceid}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const DropdownBrand = async (referenceid: number) => {
  try {
    const url = `/dropdown/v1/getbrand?referenceid=${referenceid}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const DropdownBrandGTO = async () => {
  try {
    const url = `/dropdown/v1/getbrandgto`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};


export const GetLoadingDoor = () => {
  return api.get<DropdownResponse>("/dropdown/v1/getloadingdoor");
};

export const GetActivityMaster = (referenceid: number) => {
  return api.get<DropdownResponse>(`/dropdown/v1/getactivitymaster?referenceid=${referenceid}`);
};